'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);

/******************************************************************************
 * Copyright (c) 2017, TigerGraph Inc.
 * All rights reserved.
 * Project: GVIS
 * Brief: Data Base Class.
 *
 * Created on: Oct 5th, 2016
 *      Author: Xiaoke Huang
 ******************************************************************************/

/**
 * Base Data Object Class for all Data object in the GVIS.
 * @preferred
 */
var BaseData = /*#__PURE__*/_createClass__default["default"](
/**
 * Store any additional data values within this field.
 */

/**
 * This field can be used to return any error message for any data object.
 */

function BaseData() {
  _classCallCheck__default["default"](this, BaseData);
  this.error = '';
});

exports.BaseData = BaseData;
